import limitService from "../../services/limitService";
import * as types from "./types";
import { initialState } from "./initialState";

const service = new limitService();
export const getLimitList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.FETCH_LIMIT_ROWS,
      payload: { ...initialState, loader: true },
    });
    service
      .getLimitData(data)
      .then((res) => {
        dispatch({
          type: types.FETCH_LIMIT_ROWS,
          payload: { data: res.data.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.FETCH_LIMIT_ROWS, //todo change wih api status
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit data",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const getLimitDropdown = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.API_STATUS,
      payload: { ...initialState, loader: true },
    });
    service
      .getLimitDropdown(data)
      .then((res) => {
        dispatch({
          type: types.FETCH_LIMIT_DROPDOWN,
          payload: { data: res.data.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.FETCH_LIMIT_DROPDOWN,
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit dropdown",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const AddLimitData = (data, obj) => {
  return (dispatch) => {
    dispatch({
      type: types.LIMITOPERATION,
      payload: { ...initialState, loader: true },
    });
    service
      .submitFormData(data, obj)
      .then((res) => {
        dispatch({
          type: types.LIMITOPERATION,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.LIMITOPERATION,
          payload: {
            ...initialState,
            message: error.message || "Error fetching limit dropdown",
            loader: false,
            next: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const DraftLimitData = (data, obj) => {
  return (dispatch) => {
    dispatch({
      type: types.LIMITOPERATION,
      payload: { ...initialState, draftLoader: true },
    });
    service
      .submitFormData(data, obj)
      .then((res) => {
        dispatch({
          type: types.LIMITOPERATION,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            draftLoader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.LIMITOPERATION,
          payload: {
            ...initialState,
            message: error.message || "Error fetching limit dropdown",
            draftLoader: false,
            next: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const submitFormData = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.ADD_LIMIT,
      payload: { ...initialState, loader: true },
    });
    service
      .submitFormData(data)
      .then((res) => {
        dispatch({
          type: types.ADD_LIMIT,
          payload: { data: res.data.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.ADD_LIMIT,
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit dropdown",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const ExportLimitData = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.API_STATUS,
      payload: { ...initialState, loader: true },
    });
    service
      .exportXL(data)
      .then((res) => {
        dispatch({
          type: types.EXPORT_XL_DATA,
          payload: { data: res.data.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.EXPORT_XL_DATA,
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit dropdown",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const ExportPdfLimitData = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.API_STATUS,
      payload: { ...initialState, loader: true },
    });
    service
      .exportPDF(data)
      .then((res) => {
        dispatch({
          type: types.EXPORT_PDF_DATA,
          payload: { data: res.data.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.EXPORT_PDF_DATA,
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit dropdown",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const getParaSpecList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_PARA_LIST,
      payload: { ...initialState, loader: true },
    });
    service
      .getParameterSpecificationList(data)
      .then((res) => {
        dispatch({
          type: types.GET_PARA_LIST,
          payload: { data: res.data.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_PARA_LIST,
          payload: {
            ...initialState,
            // data: Data, //todo remove this after api integration
            msg: "error",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const getSpecificationLimitNames = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_SPECIFICATION_LIMIT_NAMES,
      payload: { ...initialState, loader: true },
    });
    service
      .getSpecificationLimitNamesList(data)
      .then((res) => {
        dispatch({
          type: types.GET_SPECIFICATION_LIMIT_NAMES,
          payload: { data: res.data.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_SPECIFICATION_LIMIT_NAMES,
          payload: {
            ...initialState,
            msg: error.message || "Error fetching specification limit names",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const AddSpecificationLimitName = (obj) => {
  return (dispatch) => {
    dispatch({
      type: types.ADD_SPECIFICATION_LIMIT_NAME,
      payload: { ...initialState, loader: true },
    });
    service
      .createSpecificationLimitName(obj)
      .then((res) => {
        dispatch({
          type: types.ADD_SPECIFICATION_LIMIT_NAME,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.ADD_SPECIFICATION_LIMIT_NAME,
          payload: {
            ...initialState,
            message:
              error?.response?.data?.error ||
              error.message ||
              "Error adding specification limit name",
            loader: false,
            next: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const ImportLimitData = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.API_STATUS,
      payload: { ...initialState, loader: true },
    });
    service
      .importXL(data)
      .then((res) => {
        dispatch({
          type: types.IMPORT_LIMIT_DATA,
          payload: { data: res.data.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.IMPORT_LIMIT_DATA,
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit dropdown",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const DeleteLimit = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.LIMITOPERATION,
      payload: { ...initialState, loader: true },
    });
    service
      .deleteLimit(data)
      .then((res) => {
        dispatch({
          type: types.LIMITOPERATION,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.LIMITOPERATION,
          payload: {
            ...initialState,
            message: error.message || "Error fetching limit dropdown",
            loader: false,
            next: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const clearResponse = () => (dispatch) => {
  dispatch({
    type: types.FETCH_LIMIT_ROWS,
    payload: {
      loading: false,
      error: false,
      message: "",
      data: null,
      success: false,
    },
  });
};

export const UpdateLimit = (params, payload) => {
  return (dispatch) => {
    dispatch({
      type: types.LIMITOPERATION,
      payload: { ...initialState, loader: true },
    });
    service
      .updateLimit(params, payload)
      .then((res) => {
        dispatch({
          type: types.LIMITOPERATION,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.LIMITOPERATION,
          payload: {
            ...initialState,
            message: error.message || "Error fetching limit dropdown",
            loader: false,
            next: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};
export const DraftUpdateLimit = (params, payload) => {
  return (dispatch) => {
    dispatch({
      type: types.LIMITOPERATION,
      payload: { ...initialState, draftLoader: true },
    });
    service
      .updateLimit(params, payload)
      .then((res) => {
        dispatch({
          type: types.LIMITOPERATION,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            draftLoader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.LIMITOPERATION,
          payload: {
            ...initialState,
            message: error.message || "Error fetching limit dropdown",
            draftLoader: false,
            next: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const getAuditList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.FETCH_AUDIT_ROWS,
      payload: { ...initialState, loader: true },
    });
    service
      .getAuditList(data)
      .then((res) => {
        dispatch({
          type: types.FETCH_AUDIT_ROWS,
          payload: { data: res.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.FETCH_AUDIT_ROWS, //todo change wih api status
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit data",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const clearDropdownResponse = () => (dispatch) => {
  dispatch({
    type: types.FETCH_LIMIT_DROPDOWN,
    payload: {
      loading: false,
      error: false,
      message: "",
      data: null,
      success: false,
    },
  });
};

